/* 關張傳・第 3 章：江陵大營（關羽董督荊州時，年份不詳）
 * 一座營盤：中間是帥帳前的宴席，四周帳篷圍成一圈；醫帳在西北，三位將領各在營中一角。 */
export const TABLE = [3000, 2000], SEAT = [3000, 2080], DOCTOR = [2450, 1700], GENS = [[3600, 1650], [3550, 2450], [2400, 2380]];
export default {
  id: 'guanzhang_jiangling_ying', name: '江陵大營', W: 6000, H: 4000, seed: 2150,
  bases: [[3000, 2900], [3000, 900]],
  roads: [{ pts: [[3000, 3600], [3000, 2900], TABLE, [3000, 900], [3000, 400]], w: 140 }],
  rocks: [[900, 900, 380, 190], [5100, 900, 380, 190], [900, 3300, 380, 190], [5100, 3300, 380, 190]],
  woods: 0.4,
  sight: 0.9,
  clearings: [[TABLE[0], TABLE[1], 1000], [3000, 3400, 300], [3000, 600, 300]],
  marsh: [[4200, 2900, 200, 90], [1900, 1300, 180, 80]], // 雨後的積水
  tents: [{ x: TABLE[0], y: TABLE[1], n: 10, r: 820, chief: true, col: '#3e7b50', flag: '關' }],
};
